"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleTextField = SimpleTextField;
exports.default = TextField;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Field = _interopRequireDefault(require("../Field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SimpleTextField(p) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)('control', p.className, {
      'has-icons-left': !!p.leftIcon,
      'has-icons-right': !!p.rightIcon
    })
  }, /*#__PURE__*/_react.default.createElement("input", _extends({}, p.inputProps, {
    className: (0, _classnames2.default)('input', p.className, _defineProperty({
      'is-danger': p.danger,
      'is-success': p.success,
      'is-rounded': p.rounded
    }, "is-".concat(p.size), p.size)),
    hidden: p.hidden,
    type: p.type,
    placeholder: p.placeholder,
    onChange: p.onChange,
    onFocus: p.onFocus,
    onBlur: p.onBlur,
    onKeyPress: p.onKeyPress,
    value: p.value,
    defaultValue: p.defaultValue,
    disabled: p.disabled,
    ref: p.setRef,
    min: p.min,
    step: p.step
  })), p.leftIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small is-left"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: p.leftIcon
  })), p.rightIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small is-right"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: p.rightIcon
  })));
}

function TextField(props) {
  return /*#__PURE__*/_react.default.createElement(_Field.default, _extends({}, props, {
    className: (0, _classnames2.default)('frikin-text-field', props.className)
  }), function (fieldProps) {
    return /*#__PURE__*/_react.default.createElement(SimpleTextField, _extends({}, fieldProps, (0, _pickBy.default)(props, function (_, k) {
      return k !== 'className';
    })));
  });
}

TextField.propTypes = {
  label: _propTypes.default.any,
  value: _propTypes.default.any,
  defaultValue: _propTypes.default.any,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  danger: _propTypes.default.bool,
  success: _propTypes.default.bool,
  required: _propTypes.default.any,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'normal']),
  min: _propTypes.default.number,
  step: _propTypes.default.any,
  type: _propTypes.default.string,
  hidden: _propTypes.default.bool
};
TextField.defaultProps = {
  onChange: function onChange() {},
  type: 'text',
  size: 'normal',
  value: ''
};